// extracted by mini-css-extract-plugin
export default {"bounce":"V_fq","loading":"V_fr","logo-mark-bounce-right":"V_fs","logo-mark-bounce-left":"V_ft"};